// app/javascript/controllers/blog_posts_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    jsonUrl:   String,     // full Ghost URL inc. key/query
    renderUrl: String      // e.g. "/blog_posts/render"
  }

  connect () {
    if (this.hasJsonUrlValue && this.hasRenderUrlValue) this.load()
  }

  async load () {
    try {
      // 1. Fetch Ghost JSON
      const json = await fetch(this.jsonUrlValue, {
        headers: { Accept: "application/json" }
      }).then(r => r.json())

      // 2. POST it to Rails (expect Turbo Stream)
      const stream = await fetch(this.renderUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ posts: json.posts, target: this.element.id || null })
      }).then(r => r.text())

      // 3. Update DOM – Turbo if present, fallback otherwise
      if (window.Turbo?.renderStreamMessage) {
        window.Turbo.renderStreamMessage(stream)
      } else {
        this.element.innerHTML = stream
      }
    } catch (e) {
      console.error("BlogPostsController error", e)
      this.element.innerHTML =
        "<p class='text-danger'>Error loading articles. Please try again later.</p>"
    }
  }
}
